import {
    useAppDispatch,
    useAppSelector,
} from 'hooks'
import ChannelInvitePeoplePromiseModal from 'components/Modal/ChannelInvitePeoplePromiseModal'
import {ChannelMenubarProps} from './types'
import ChannelMenubarView from './ChannelMenubarView'
import React from 'react'
import {jitsiToggleChat} from 'actions/jitsi'
import {navigation} from 'navigation'
import permissionGuard from 'components/Navigation/helpers/PermissionGuard'
import {useChannelDetails} from 'hooks/ninchat'
import {usePromiseModal} from 'components/Modal/PromiseModal/hooks/usePromiseModal'

const ChannelMenubar = (props: ChannelMenubarProps): React.ReactElement => {
    const {
        chat,
        isActiveVideoChannel,
        isChannelSidebarOpen,
        isChatOpen,
        onToggleChannelSidebar,
    } = props

    const channelId = chat.channel_id
    const dispatch = useAppDispatch()
    const openChannelInvitePeopleModal = usePromiseModal(ChannelInvitePeoplePromiseModal, {instanceId: 'channelInvite'})

    const hasChannelPermission = permissionGuard.hasManageRealmChannelPermissions(channelId || '')

    const isChannelClosed = useAppSelector(({ninchat}): boolean => {
        if (!channelId) {
            return false
        }
        return ninchat.user_channels[channelId]?.channel_attrs?.closed === true
    })

    const isVideoChannel = useAppSelector(({ninchat}): boolean => {
        if (!channelId) {
            return false
        }
        return ninchat.user_channels[channelId]?.channel_attrs?.video === 'group'
    })

    const channelDetails = useChannelDetails({channelId})

    const hasUnreadMessages = !isChatOpen && ['unread', 'highlight'].includes(channelDetails?.channelStatus ?? '')

    const onChannelSettings = (): void => {
        if (channelId) {
            navigation.push('ChannelSettings', {channel_id: channelId})
        }
    }

    const onChannelInvite = () => {
        if (channelId) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            openChannelInvitePeopleModal({channelId}).then(() => {}, () => {})
        }
    }

    const onToggleChat = (): void => {
        if (isChatOpen && isChannelSidebarOpen) {
            onToggleChannelSidebar()
        } else if (!isChatOpen && isChannelSidebarOpen) {
            onToggleChannelSidebar()
            dispatch(jitsiToggleChat())
        } else {
            dispatch(jitsiToggleChat())
        }
    }

    return (
        <ChannelMenubarView
            chat={chat}
            hasChannelPermission={hasChannelPermission}
            hasUnreadMessages={hasUnreadMessages}
            isActiveVideoChannel={isActiveVideoChannel}
            isChannelClosed={isChannelClosed}
            isChannelSidebarOpen={isChannelSidebarOpen}
            isVideoChannel={isVideoChannel}
            onChannelInvite={onChannelInvite}
            onChannelSettings={onChannelSettings}
            onToggleChannelSidebar={onToggleChannelSidebar}
            onToggleChat={onToggleChat}
        />
    )
}

export default ChannelMenubar
